import { lazy } from 'react';

export const CalculationRatios = lazy(() =>
    import('./UerCalculationRatios').then((module) => ({ default: module.CalculationRatios })),
);
